<template>
<div>
  <div class="fields-block" v-if="hotelBooking">
    <h2 class="mb-3">{{ $t('payment.travel.parking') }}</h2>
    <div class="row">
      <div class="col-6 field-col">
        <div class="fields-area">
          <input-select
            v-model="parking_arrival_time"
            id="outbound_terminal" 
            :options="timeOptions"
            :inline="false"
            optionType="Array"
            label="payment.travel.parking_arrival" 
          />
        </div>
      </div>
      <div class="col-6 field-col">
        <div class="fields-area">
          <input-select
            v-model="parking_departure_time"
            id="outbound_terminal" 
            :options="timeOptions"
            :inline="false"
            optionType="Array"
            label="payment.travel.parking_departure" 
          />
        </div>
      </div>
    </div>
  </div>
  <div class="fields-block" v-if="meetGreet">
    <h2 class="mb-3">{{ $t('payment.travel.meet_greet') }}</h2>
    <span class="sub-text">{{ $t('payment.travel.meet_greet_confirm') }}.</span>
    <div class="row">
      <div class="col-12 field-col">
        <div class="fields-area">
          <input-select
            v-model="meet_time"
            id="outbound_terminal" 
            :options="timeOptions"
            :inline="false"
            optionType="Array"
            label="payment.travel.meet_time" 
          />
        </div>
      </div>
    </div>
  </div>
  <div class="fields-block terminal-block">
    <h2>{{ $t(`payment.travel.${meetGreet ? 'flight_details' : 'flight_details_optional'}`) }}</h2>
    <span v-if="!meetGreet" class="sub-text">{{ $t('payment.travel.confirm') }}</span>
    <div class="row">
      <div class="col-md-6 field-col">
        <div class="fields-area style01" v-if="shortTerminals">
          <input-select
            v-model="outbound_terminal"
            id="outbound_terminal" 
            :options="shortTerminals"
            :inline="true"
            label="payment.travel.terminal_out" 
          />
          <input-base
            v-model="outbound_flight"
            id="outbound" 
            type="text" 
            label="payment.travel.outbound" 
          />
        </div>
      </div>
      <div class="col-md-6 field-col">
        <div class="fields-area style01" v-if="shortTerminals">
          <input-select
            v-model="return_terminal"
            id="inbound_terminal" 
            :options="shortTerminals"
            :inline="true"
            label="payment.travel.terminal_in" 
          />
          <input-base
            v-model="return_flight_number"
            id="inbound" 
            type="text" 
            label="payment.travel.inbound" 
            :invalid="value.travelDetails.return_flight_number.$error"
            @change="value.travelDetails.return_flight_number.$touch()"
            />
            <span class="error">{{ validationMsg(value.travelDetails.return_flight_number) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { sync, get } from "vuex-pathify";
import { InputBase, InputSelect } from "@/components";
import mixins from "@/mixins";
import times from "@/utils/timeOptions";

export default {
  name: "travel-details",
  mixins: [mixins.format, mixins.validate],
  components: { InputBase, InputSelect },
  props: ['value'],
  data() {
    return {
      timeOptions: times,
    }
  },
  computed: {
    ...sync("payment/travelDetails@.*"),
    category: get("quote/category"),
    cart: get("cart/products"),
    meetGreet() {
      return this.category === 'airportparking' && this.cart.airportparking.length > 0 && this.cart.airportparking[0].product.park_type === "Chauffeur";
    },
    hotelBooking() {
      return this.category === 'airporthotel'
    },
    terminals: get("results/airport@terminals"),
    shortTerminals() {
      let terminals = this.terminals ? this.terminals : 'T1, T2, T3, T4, T5, North, South, Main' ;
      return terminals.split(',').map(t => {
        return { label: this.terminalShorten(t), value: t }
      })
    }
  }
};
</script>